import { LogoutOutlined, MenuOutlined } from "@ant-design/icons";
import { Button, Layout, Space, Typography } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../../features/auth/model/AuthContext";
import { PATHS } from "../router/paths";
import AccountMenu from "./AccountMenu";

const { Header } = Layout;

type TopHeaderProps = {
  onShowSidebar: () => void;
};

const TopHeader = ({ onShowSidebar }: TopHeaderProps) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [loggingOut, setLoggingOut] = useState(false);
  const username = user?.display_name || user?.email || "ユーザー";

  const handleLogout = async () => {
    setLoggingOut(true);
    try {
      await logout();
      navigate(PATHS.AUTH.LOGIN, { replace: true });
    } finally {
      setLoggingOut(false);
    }
  };

  return (
    <Header
      style={{
        height: 56,
        padding: "0 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        background: "#fff",
        borderBottom: "1px solid #f0f0f0",
      }}
    >
      <Space>
        <Button
          type="text"
          shape="circle"
          icon={<MenuOutlined />}
          onClick={onShowSidebar}
          aria-label="メニューを開く"
          style={{ background: "#f5f5f5", width: 40, height: 40 }}
        />
        <Typography.Title level={5} style={{ margin: 0 }}>
          Customer Home
        </Typography.Title>
      </Space>

      <Space size={8} style={{ flexShrink: 0 }}>
        <span
          style={{
            padding: "4px 8px",
            borderRadius: 999,
            background: "#fff1f0",
            color: "#cf1322",
            fontSize: 12,
            fontWeight: 600,
            whiteSpace: "nowrap",
          }}
        >
          デモ用環境
        </span>
        <AccountMenu
          username={username}
          avatarUrl={user?.avatar_url}
          actions={[
            {
              key: "logout",
              label: "ログアウト",
              icon: <LogoutOutlined />,
              danger: true,
              loading: loggingOut,
              onClick: handleLogout,
            },
          ]}
        />
      </Space>
    </Header>
  );
};

export default TopHeader;
